import { Download, ExternalLink } from 'lucide-react';
import type { McpCatalogEntry } from '../types';

type Props = {
  entries: McpCatalogEntry[];
  onConfigure: (entry: McpCatalogEntry) => void;
};

export default function CatalogBrowser({ entries, onConfigure }: Props) {
  if (entries.length === 0) {
    return (
      <div className="mcp-v2__panel">
        <div className="mcp-v2__empty">
          <h3>No catalog matches</h3>
          <p>Try a different search or clear tag filters.</p>
        </div>
      </div>
    );
  }

  return (
    <div className="mcp-v2__catalog-grid">
      {entries.map((entry) => (
        <article key={entry.id} className="mcp-v2__catalog-card">
          <div>
            <div className="mcp-v2__meta" style={{ marginBottom: 6 }}>
              <span className="mcp-v2__pill mcp-v2__pill--transport">{entry.transport}</span>
              <span>{entry.publisher}</span>
            </div>
            <h3>{entry.name}</h3>
          </div>
          <p>{entry.description}</p>
          <div className="mcp-v2__meta">
            <span>{entry.toolCount} tools</span>
            <span>·</span>
            <span>{entry.resourceCount} resources</span>
          </div>
          <div className="mcp-v2__meta">
            {entry.tags.map((t) => (
              <span key={t} className="mcp-v2__tag">
                {t}
              </span>
            ))}
          </div>
          <div className="mcp-v2__actions">
            <button
              type="button"
              className="mcp-v2__btn mcp-v2__btn--primary"
              onClick={() => onConfigure(entry)}
            >
              <Download className="w-3.5 h-3.5" aria-hidden />
              Download &amp; configure
            </button>
            <a
              className="mcp-v2__btn mcp-v2__btn--ghost"
              href={entry.repoUrl}
              target="_blank"
              rel="noopener noreferrer"
              onClick={(e) => e.stopPropagation()}
            >
              <ExternalLink className="w-3.5 h-3.5" aria-hidden />
              Repo
            </a>
          </div>
        </article>
      ))}
    </div>
  );
}
